import { render, staticRenderFns } from "./MaquinaClasificacion.vue?vue&type=template&id=55afe86e&"
import script from "./MaquinaClasificacion.vue?vue&type=script&lang=js&"
export * from "./MaquinaClasificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports